var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container delivery-setting-page" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessLogisticsProductLang.productEdit")) +
              " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onCancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("backText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "section",
        { staticClass: "setting-card summary-card" },
        _vm._l(_vm.summaryItems, function (item) {
          return _c(
            "div",
            { key: item.labelKey, staticClass: "summary-item" },
            [
              _c("span", { staticClass: "summary-label" }, [
                _vm._v(_vm._s(_vm.$t(item.labelKey)) + ":"),
              ]),
              item.tagType
                ? _c(
                    "el-tag",
                    { attrs: { size: "mini", type: item.tagType } },
                    [_vm._v(_vm._s(item.value))]
                  )
                : _c("span", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(item.value || "")),
                  ]),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "section",
        { staticClass: "setting-card config-card" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "setting-tabs",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            _vm._l(_vm.tabs, function (tab) {
              return _c(
                "el-tab-pane",
                {
                  key: tab.name,
                  attrs: {
                    name: tab.name,
                    label: _vm.$t(tab.labelKey),
                    disabled: tab.disabled,
                  },
                },
                [
                  tab.name === "zone"
                    ? _c(
                        "div",
                        { staticClass: "tab-pane-body" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "zoneForm",
                              refInFor: true,
                              staticClass: "zone-form",
                              attrs: {
                                model: _vm.zoneForm,
                                rules: _vm.zoneRules,
                                "label-position": "top",
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "BusinessLogisticsProductLang.serviceZone"
                                    ),
                                    prop: "customerLogisticsGroupDictServiceId",
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      "option-list": _vm.zoneOptions1,
                                      placeholder: _vm.$t(
                                        "BusinessLogisticsProductLang.serviceZone"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.zoneForm
                                          .customerLogisticsGroupDictServiceId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.zoneForm,
                                          "customerLogisticsGroupDictServiceId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "zoneForm.customerLogisticsGroupDictServiceId",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "BusinessLogisticsProductLang.remoteZone"
                                    ),
                                    prop: "customerLogisticsGroupDictRemoteId",
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      "option-list": _vm.zoneOptions2,
                                      placeholder: _vm.$t(
                                        "BusinessLogisticsProductLang.remoteZone"
                                      ),
                                    },
                                    model: {
                                      value:
                                        _vm.zoneForm
                                          .customerLogisticsGroupDictRemoteId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.zoneForm,
                                          "customerLogisticsGroupDictRemoteId",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "zoneForm.customerLogisticsGroupDictRemoteId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "tab-pane-body" }),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "footer-actions" },
        [
          _c(
            "el-button",
            { staticClass: "footer-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("cancelText")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "footer-btn",
              attrs: { type: "primary" },
              on: { click: _vm.onSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("okText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }